import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { PasswordInput } from "@/components/PasswordInput";
import { Checkbox } from "@/components/ui/checkbox";
import { DatePicker } from "@/components/DatePicker";
import { api, errMsg, normPhone } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { AuthShell } from "@/pages/Login";

export default function Register() {
  const { signIn } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ name: "", email: "", phone: "", password: "", dob: "", accept_terms: false });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const up = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      const { data } = await api.post("/auth/register", f);
      signIn(data.token, data.user);
      nav("/companions");
    } catch (e2) {
      setErr(errMsg(e2));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell title="Create account" sub="Book verified companions. You must be 18 or older.">
      <form onSubmit={submit} className="space-y-4" data-testid="register-form" noValidate>
        <Input data-testid="register-name-input" placeholder="Full name" value={f.name} onChange={up("name")} />
        <Input data-testid="register-email-input" type="email" placeholder="Email" value={f.email} onChange={up("email")} />
        <Input data-testid="register-phone-input" inputMode="numeric" placeholder="10-digit mobile number (visible only to RentMyDate staff)" value={f.phone} onChange={(e) => setF({ ...f, phone: normPhone(e.target.value) })} />
        <PasswordInput data-testid="register-password-input" placeholder="Password (min 8 characters)" value={f.password} onChange={up("password")} />
        <div className="text-sm text-slate-600 space-y-1">Date of birth (must be 18+)
          <DatePicker testId="register-dob-input" dob value={f.dob} onChange={(v) => setF({ ...f, dob: v })} />
        </div>
        <label className="flex items-start gap-3 text-sm text-slate-600 cursor-pointer">
          <Checkbox data-testid="register-terms-checkbox" checked={f.accept_terms} onCheckedChange={(v) => setF({ ...f, accept_terms: !!v })} className="mt-0.5" />
          <span>I am 18+ and accept the <Link to="/terms" className="underline">Terms</Link>, <Link to="/privacy" className="underline">Privacy Policy</Link> and <Link to="/guidelines" className="underline">Community Guidelines</Link>.</span>
        </label>
        {err && <p className="text-sm text-rose-600" data-testid="register-error">{err}</p>}
        <Button data-testid="register-submit-btn" className="w-full h-11 rounded-full" disabled={busy}>{busy ? <Loader2 className="animate-spin" /> : "Create account"}</Button>
      </form>
      <p className="text-sm text-slate-600">Already have an account? <Link to="/login" className="font-semibold text-[#0D5C46]">Log in</Link></p>
    </AuthShell>
  );
}
